document.addEventListener("DOMContentLoaded", function () {
  const thumbsDesktop = new Swiper(".mainGalleryThumbs", {
    spaceBetween: 16,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    direction: "vertical",
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".mainGalleryThumbs-button-next",
      prevEl: ".mainGalleryThumbs-button-prev",
    },
  });

  const thumbsMobile = new Swiper(".mainGalleryThumbsMobile", {
    spaceBetween: 16,
    slidesPerView: 3,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });

  const main = new Swiper(".mainGallery", {
    spaceBetween: 16,
    slidesPerView: 1,
    navigation: {
      nextEl: ".mainGallery-button-next",
      prevEl: ".mainGallery-button-prev",
    },
    on: {
      init(sw) {
        sw.el.classList.add('swiper-initialized');
        const i = sw.activeIndex || 0;
        thumbsDesktop.slideTo(i, 0);
        thumbsMobile.slideTo(i, 0);
        updateThumbActive(i);
      },
    },
  });

  function enableThumbClick(swiper) {
    swiper.on("click", () => {
      const i = swiper.clickedIndex;
      if (typeof i === "number" && i >= 0) {
        main.slideTo(i);
        thumbsDesktop.slideTo(i);
        thumbsMobile.slideTo(i);
        updateThumbActive(i);
      }
    });
  }
  enableThumbClick(thumbsDesktop);
  enableThumbClick(thumbsMobile);

  main.on("slideChange", () => {
    const i = main.activeIndex;
    thumbsDesktop.slideTo(i);
    thumbsMobile.slideTo(i);
    updateThumbActive(i);
  });

  function updateThumbActive(activeIndex) {
    [thumbsDesktop, thumbsMobile].forEach((sw) => {
      sw.slides.forEach((sl) => sl.classList.remove("is-thumb-active"));
      const s = sw.slides[activeIndex];
      if (s) s.classList.add("is-thumb-active");
      sw.updateSlidesClasses();
    });
  }

  // Slide gallery to a specific media ID
  function slideToMediaId(mediaId) {
    if (!mediaId) return;
    const slides = Array.from(
      document.querySelectorAll(".mainGallery .swiper-wrapper > .swiper-slide")
    );
    const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
    if (idx < 0) return;
    main.slideTo(idx);
    thumbsDesktop.slideTo(idx);
    thumbsMobile.slideTo(idx);
    updateThumbActive(idx);
  }

  // Info section tabs
  const SINGLE_OPEN = true;
  const sections = document.querySelectorAll(".product-info");

  const setOpenState = (section, open) => {
    const btn = section.querySelector(".product-info-button");
    const content = section.querySelector(".product-info-content");
    const plus = section.querySelector(".product-info-button .plus");
    const minus = section.querySelector(".product-info-button .minus");

    if (!btn || !content || !plus || !minus) return;

    if (open) {
      content.classList.remove("hidden");
      plus.classList.add("hidden");
      minus.classList.remove("hidden");
      btn.setAttribute("aria-expanded", "true");
    } else {
      content.classList.add("hidden");
      plus.classList.remove("hidden");
      minus.classList.add("hidden");
      btn.setAttribute("aria-expanded", "false");
    }
  };

  sections.forEach((section) => {
    const btn = section.querySelector(".product-info-button");
    if (!btn) return;

    setOpenState(section, false);
    btn.setAttribute("aria-controls", "");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("type", "button");

    btn.addEventListener("click", () => {
      const content = section.querySelector(".product-info-content");
      const isOpen = !content.classList.contains("hidden");
      if (SINGLE_OPEN && !isOpen) {
        sections.forEach((s) => s !== section && setOpenState(s, false));
      }
      setOpenState(section, !isOpen);
    });
  });

  // Product quantity inputs
  const productQtyInputs = document.querySelectorAll(".product-qty");
  productQtyInputs.forEach((input) => {
    const wrapper = input.closest("div");
    if (!wrapper) return;

    const minusBtn = wrapper.querySelector("button:first-of-type");
    const plusBtn = wrapper.querySelector("button:last-of-type");

    let value = parseInt(input.value, 10) || 1;

    const updateValue = (newVal) => {
      const maxValue = parseInt(input.dataset.max) || 9999;
      if (newVal < 1) newVal = 1;
      if (newVal > maxValue) newVal = maxValue;
      value = newVal;
      input.value = value;
    };

    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value - 1);
    });

    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value + 1);
    });
  });

  // Scroll gallery to variant image - patch ProductVariantSelector directly
  function patchVariantSelector(el) {
    if (!el || el._galleryPatched) return;
    el._galleryPatched = true;

    const original = el.selectVariant.bind(el);
    el.selectVariant = async function (variantId) {
      await original(variantId);
      const variant = this.variants.find(
        (v) => v.id === (typeof variantId === 'string' ? parseInt(variantId, 10) : variantId)
      );
      if (variant?.featured_media?.id) {
        slideToMediaId(variant.featured_media.id);
      }

      // PriceSpider rebind on variant switch
      if (variant?.sku) {
        const psSku = document.querySelector('meta[name="ps-sku"]');
        if (psSku) {
          psSku.setAttribute('content', variant.sku);
        }
        if (window.PriceSpider) {
          window.PriceSpider.rebind();
        }
      }
    };
  }

  // Patch on load
  document.querySelectorAll('product-variant-selector').forEach(patchVariantSelector);

  // Re-patch if LSG replaces the element
  const observer = new MutationObserver(() => {
    document.querySelectorAll('product-variant-selector').forEach(patchVariantSelector);
  });
  observer.observe(document.body, { childList: true, subtree: true });

});


// GA4 Events Helper
(function () {
  let attempts = 0;

  function waitForGtag() {
    attempts++;
    if (typeof window.gtag === 'function') {
      setupTracking();
    } else if (attempts < 50) {
      setTimeout(waitForGtag, 100);
    }
  }

  function setupTracking() {
    const retailerMap = {
      'walmart': 'pdp_click_walmart',
      'amazon': 'pdp_click_amazon',
      'target': 'pdp_click_target',
      'chewy': 'pdp_click_chewy',
      'petsmart': 'pdp_click_petsmart',
      'tractorsupply': 'pdp_click_tractorsupply',
      'tractor supply': 'pdp_click_tractorsupply',
      'petco': 'pdp_click_petco',
    };

    function getEventNameFromText(text) {
      const lowerText = text.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerText.includes(key)) return value;
      }
      return 'pdp_click_other_retailer';
    }

    function getEventNameFromUrl(url) {
      const lowerUrl = url.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerUrl.includes(key)) return value;
      }
      return 'pdp_click_other_retailer';
    }

    function getDomain(url) {
      try {
        return new URL(url).hostname.replace(/^www\./, '').toLowerCase();
      } catch (e) {
        return '';
      }
    }

    document.addEventListener('click', function (e) {
      const psContainer = e.target.closest('.ps-wtb');
      if (!psContainer) return;

      const button = e.target.closest('button.ps-online-buy-button, button.ps-online-seller-button');
      if (button) {
        const ariaLabel = button.getAttribute('aria-label') || '';
        const buttonText = button.textContent || '';
        const combinedText = ariaLabel + ' ' + buttonText;
        const eventName = getEventNameFromText(combinedText);

        window.gtag('event', eventName, {
          button_text: buttonText.trim(),
          aria_label: ariaLabel,
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon',
        });
        return;
      }

      const link = e.target.closest('a');
      if (link && link.href) {
        const url = link.href;
        const eventName = getEventNameFromUrl(url);

        window.gtag('event', eventName, {
          link_url: url,
          retailer_domain: getDomain(url),
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon',
        });
      }
    }, true);
  }

  waitForGtag();
})();


document.addEventListener('DOMContentLoaded', () => {
  const targetId = window.__scrollTarget;
  if (!targetId) return;

  let lastHeight = 0;
  let stableCount = 0;

  const interval = setInterval(() => {
    const currentHeight = document.body.scrollHeight;
    if (currentHeight === lastHeight) {
      stableCount++;
    } else {
      stableCount = 0;
      lastHeight = currentHeight;
    }

    if (stableCount >= 5) {
      clearInterval(interval);
      const el = document.getElementById(targetId);
      if (el) {
        const headerWrap = document.querySelector('.header-wrap');
        const navHeight = headerWrap ? headerWrap.offsetHeight + 40 : 120;
        const top = el.getBoundingClientRect().top + window.scrollY - navHeight - 16;
        window.scrollTo({ top, behavior: 'smooth' });
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${targetId}`);
      }
    }
  }, 200);

  setTimeout(() => clearInterval(interval), 15000);
});